export default function EmployeeInvite(vm) {
    this.create = function(params) {
        var url = '/invite/employee';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/invite/employee/' + id;

        return vm.get(url);
    };
}